import {useMemo} from 'react'
import {useSuspenseQuery} from '@github-ui/react-query'
import {getAllRegisteredCommands} from '@github-ui/ui-commands/internal'
import {getQueryOptions, type APIShortcuts} from './keyboard-shortcuts-query-options'

import {normalizeShortcuts, type NormalizedShortcuts} from './normalize-commands'

function transformShortcuts(apiShortcuts: APIShortcuts | null): NormalizedShortcuts {
  const uiCommandGroups = getAllRegisteredCommands()

  return normalizeShortcuts(uiCommandGroups, apiShortcuts)
}

export function useKeyboardShortcutsQuery(contexts: string | undefined) {
  const options = useMemo(() => ({...getQueryOptions(contexts), select: transformShortcuts}), [contexts])
  return useSuspenseQuery(options)
}
